<template>
<div class="escape100-container">
	<div class="escape100-card">

		<div class="escape100__header" :style="`background-image: url(${$filters.analyseImage(payload.cover_image, 'herosearchxs', 'herosearchsm')});`">
			<!-- <block-alert :org_main_id="payload['org-main-id']" :org_name="payload['org-name']"></block-alert> -->
			<div v-if="e100Details" class="escape100__header-number">{{ e100Details['position'] }}</div>
			<div class="escape100__header-logo-container">
				<img class="escape100__header-logo" :src="$filters.analyseImage(payload.logo,'logosm','logoxl')" :alt="payload['org-name']" width="54" loading="lazy">
			</div>
		</div>

		<div class="escape100__wrapper">

				<div class="escape100__body">
          <div class="escape100__body-header">
            <h4 class="escape100__body-title">
              <p v-if="payload['org-name']" v-html="payload['org-name']"></p>
              <p v-if="payload['city'] || payload['country']" class="escape100__body-location">{{ ((payload['city']) ? payload['city']+', ' : '') + ((payload['country']) ? payload['country'] : '') }}</p>
            </h4>
            <a :href="`/search/jobs?q=org-name=${payload['org-name']}`" class="btn btn-blue-dark btn-medium escape100__body-jobs" v-if="payload['listings-live']">{{ jobListings(payload['listings-live']) }}</a>
          </div>
					<p class="escape100__body-text" v-if="payload['summary']" v-html="payload['summary']"></p>
				</div>
				<div class="escape100__footer">
					<div class="escape100__footer-container">
						<div class="escape100__footer-item" v-if="payload['e100-score']">
							{{ payload['e100-score'] }} ESCAPE SCORE
						</div>
						<div class="escape100__footer-item"  v-if="payload['size']">
							{{ payload['size'] }} EMPLOYEES
						</div>
						<div class="escape100__footer-item"  v-if="payload['review-score-latest']">
							{{ payload['review-score-latest'].toFixed(1) }} EMPLOYEE RATING
						</div>
					</div>

					<label v-if="e100Details" class="more-info-label" :for="`more-info-${score}`" @click="doMoreInfo" :aria-label="moreInfoText">{{ moreInfoText }}</label>
				</div>

		</div>
	</div>

	<input class="more-info-checkbox" type="checkbox" :id="`more-info-${score}`" :name="`more-info-${score}`">

	<div class="escape100__dropdown" v-if="e100Details">

		<div class="escape100__dropdown-item">
			<div class="escape-score">
				<h3 class="escape-score-title">Escape score</h3>

        <template v-if="e100Details['score-detail'] && e100Details['score-detail'].length">
          <!-- IMPACT -->
          <div class="dropdown__card">
            <input class="dropdown-checkbox" type="checkbox" :id="`impact-${payload['org-main-id']}`" :name="`impact-${payload['org-main-id']}`">

            <label class="dropdown-btn" :for="`impact-${payload['org-main-id']}`" aria-label="Open">
              <p>IMPACT</p>
              <ul class="dropdown-btn-awards" v-if="getScoreDetail('Impact')[0]['stars']">
                <li v-for="stars in Number(getScoreDetail('Impact')[0]['stars'])" :key="stars">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"/></svg>
                </li>
              </ul>
              <div class="dropdown-btn-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </label>

            <div class="dropdown-body">
              <p>Our "Impact" measure is the foundation of our judging criteria. Not only does it denote how far-reaching the organisation’s work is in the world, but it also affects both the “Mission” and “Planet” criteria.</p>
              <p>An organisation’s mission is multiplied if its impact is far-reaching. Similarly, an organisation’s environmental footprint is multiplied by its scale. In this way, the impact criteria has an important bearing on our calculation.</p>
              <template v-if="getScoreDetail('Impact')[0]['judged-outcome']">
                <p class="awarded-category">AWARDED CATEGORY</p>
                <button v-if="getScoreDetail('Impact')[0]['judged-outcome']" class="awarded-category-btn" @click="escapeScorePopup('Impact', getScoreDetail('Impact')[0]['judged-outcome'])" aria-label="OpenPopup">
                  <span>{{ getScoreDetail('Impact')[0]['judged-outcome'] }}</span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"/></svg>
                  </span>
                </button>
              </template>
            </div>
          </div>
          <!-- MISSION -->
          <div class="dropdown__card">
            <input class="dropdown-checkbox" type="checkbox" :id="`mission-${payload['org-main-id']}`" :name="`mission-${payload['org-main-id']}`">

            <label class="dropdown-btn" :for="`mission-${payload['org-main-id']}`" aria-label="Open">
              <p>MISSION</p>
              <ul class="dropdown-btn-awards" v-if="getScoreDetail('Mission')[0]['stars']">
                <li v-for="stars in Number(getScoreDetail('Mission')[0]['stars'])" :key="stars">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"/></svg>
                </li>
              </ul>
              <div class="dropdown-btn-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </label>

            <div class="dropdown-body">
              <p>Our "Mission" criterion refers to the aims and ambitions of an organisation.</p>
              <template v-if="getScoreDetail('Mission')[0]['judged-outcome']">
                <p class="awarded-category">AWARDED CATEGORY</p>
                <button  v-if="getScoreDetail('Mission')[0]['judged-outcome']" class="awarded-category-btn" @click="escapeScorePopup('Mission', getScoreDetail('Mission')[0]['judged-outcome'])" aria-label="OpenPopup">
                  <span>{{ getScoreDetail('Mission')[0]['judged-outcome'] }}</span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"/></svg>
                  </span>
                </button>
              </template>
            </div>
          </div>
          <!-- PLANET -->
          <div class="dropdown__card">
            <input class="dropdown-checkbox" type="checkbox" :id="`planet-${payload['org-main-id']}`" :name="`planet-${payload['org-main-id']}`">

            <label class="dropdown-btn" :for="`planet-${payload['org-main-id']}`" aria-label="Open">
              <p>PLANET</p>
              <ul class="dropdown-btn-awards" v-if="getScoreDetail('Planet')[0]['stars']">
                <li v-for="stars in Number(getScoreDetail('Planet')[0]['stars'])" :key="stars">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"/></svg>
                </li>
              </ul>
              <div class="dropdown-btn-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </label>

            <div class="dropdown-body">
              <p>Our "Mission" criterion refers to the aims and ambitions of an organisation.</p>
              <template v-if="getScoreDetail('Planet')[0]['judged-outcome']">
                <p class="awarded-category">AWARDED CATEGORY</p>
                <button class="awarded-category-btn" @click="escapeScorePopup('Planet', getScoreDetail('Planet')[0]['judged-outcome'])" aria-label="OpenPopup">
                  <span>{{ getScoreDetail('Planet')[0]['judged-outcome'] }}</span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"/></svg>
                  </span>
                </button>
              </template>
            </div>
          </div>
          <!-- PEOPLE -->
          <div class="dropdown__card">
            <input class="dropdown-checkbox" type="checkbox" :id="`people-${payload['org-main-id']}`" :name="`people-${payload['org-main-id']}`">

            <label class="dropdown-btn" :for="`people-${payload['org-main-id']}`" aria-label="Open">
              <p>PEOPLE</p>
              <ul class="dropdown-btn-awards" v-if="getScoreDetail('People')[0]['stars']">
                <li v-for="stars in Number(getScoreDetail('People')[0]['stars'])" :key="stars">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"/></svg>
                </li>
              </ul>
              <div class="dropdown-btn-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </label>

            <div class="dropdown-body">
              <p>Our "Mission" criterion refers to the aims and ambitions of an organisation.</p>
              <template v-if="getScoreDetail('People')[0]['judged-outcome'] && getScoreDetail('People')[1]['judged-outcome']">
                <p class="awarded-category">AWARDED CATEGORY</p>
                <button v-if="getScoreDetail('People')[0]['judged-outcome']" class="awarded-category-btn" @click="escapeScorePopup('People', getScoreDetail('People')[0]['judged-outcome'])" aria-label="OpenPopup">
                  <span><span>POLICY RATING</span>{{ getScoreDetail('People')[0]['judged-outcome'] }}</span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"/></svg>
                  </span>
                </button>
                <button v-if="getScoreDetail('People')[0]['judged-outcome']" class="awarded-category-btn employee-rating" @click="escapeScorePopup('People2', getScoreDetail('People')[1]['judged-outcome'])" aria-label="OpenPopup">
                  <span><span>EMPLOYEE RATING (/10)</span>{{ getScoreDetail('People')[1]['judged-outcome'] }}</span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"/></svg>
                  </span>
                </button>
              </template>
            </div>
          </div>
          <!-- INNOVATION -->
          <div class="dropdown__card">
            <input class="dropdown-checkbox" type="checkbox" :id="`innovation-${payload['org-main-id']}`" :name="`innovation-${payload['org-main-id']}`">

            <label class="dropdown-btn" :for="`innovation-${payload['org-main-id']}`" aria-label="Open">
              <p>INNOVATION</p>
              <ul class="dropdown-btn-awards" v-if="getScoreDetail('Innovation')[0]['stars']">
                <li v-for="stars in Number(getScoreDetail('Innovation')[0]['stars'])" :key="stars">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"/></svg>
                </li>
              </ul>
              <div class="dropdown-btn-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </label>

            <div class="dropdown-body">
              <p>Our "Mission" criterion refers to the aims and ambitions of an organisation.</p>
              <template v-if="getScoreDetail('Innovation')[0]['judged-outcome']">
                <p class="awarded-category">AWARDED CATEGORY</p>
                <button class="awarded-category-btn" @click="escapeScorePopup('Innovation', getScoreDetail('Innovation')[0]['judged-outcome'])" aria-label="OpenPopup">
                  <span>{{ getScoreDetail('Innovation')[0]['judged-outcome'] }}</span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"/></svg>
                  </span>
                </button>
              </template>
            </div>
          </div>
          <!-- B CORP -->
          <div class="dropdown__card">
            <input class="dropdown-checkbox" type="checkbox" :id="`bcorp-${payload['org-main-id']}`" :name="`bcorp-${payload['org-main-id']}`">

            <label class="dropdown-btn" :for="`bcorp-${payload['org-main-id']}`" aria-label="Open">
              <p>B CORP</p>
              <ul class="dropdown-btn-awards" v-if="getScoreDetail('B Corp')[0]['stars']">
                <li v-for="stars in Number(getScoreDetail('B Corp')[0]['stars'])" :key="stars">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"/></svg>
                </li>
              </ul>
              <div class="dropdown-btn-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </label>

            <div class="dropdown-body">
              <p>Our "Mission" criterion refers to the aims and ambitions of an organisation.</p>
              <template v-if="getScoreDetail('B Corp')[0]['judged-outcome']">
                <p class="awarded-category">AWARDED CATEGORY</p>
                <button class="awarded-category-btn" @click="escapeScorePopup('B Corp', getScoreDetail('B Corp')[0]['judged-outcome'])" aria-label="OpenPopup">
                  <span>{{ getScoreDetail('B Corp')[0]['judged-outcome'] }}</span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"/></svg>
                  </span>
                </button>
              </template>
            </div>
          </div>
        </template>

        <div class="total" v-if="e100Details['score']">
          <p>Total</p>
          <p>{{ e100Details['score'] }}</p>
        </div>

        <a v-if="e100Details['slug']" class="escape-score__link" :href="`/organisation/${e100Details['slug']}`">View profile</a>
      </div>
		</div>

		<div class="escape100__dropdown-item">
			<div class="overview" v-if="e100Details['esc-team-review']">
				<div class="overview__person">
					<div class="img-avatar" v-if="e100Details['esc-team-review']['image']" :style="{'background-image': `url(${$filters.analyseImage(e100Details['esc-team-review']['image'],'logosm','logoxl')})`}"></div>
					<div class="overview__details">
						<h5 v-if="e100Details['esc-team-review']['name']" class="overview__name">{{ e100Details['esc-team-review']['name'] }}</h5>
						<p v-if="e100Details['esc-team-review']['title']" class="overview__title">{{ e100Details['esc-team-review']['title'] }}</p>
					</div>
				</div>

				<div v-if="e100Details['esc-team-review']['review']" class="overview__description">
          <p>{{ e100Details['esc-team-review']['review'] }}</p>
				</div>
			</div>

			<div class="employee-reviews">
				<h3 v-if="e100Details['review-count']" class="employee-reviews-title">
					{{ e100Details['review-count'] }} Employee reviews
				</h3>

				<div v-if="e100Details['employee-rating']" class="employee-reviews-ratings">
					<ul class="employee-reviews-ratings-stars">
						<li>
							<svg :class="{'active': e100Details['employee-rating'] > 0}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg>
						</li>
						<li>
							<svg :class="{'active': e100Details['employee-rating'] > 2}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg>
						</li>
						<li>
							<svg :class="{'active': e100Details['employee-rating'] > 4}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg>
						</li>
						<li>
							<svg :class="{'active': e100Details['employee-rating'] > 6}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg>
						</li>
						<li>
							<svg :class="{'active': e100Details['employee-rating'] > 8}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/></svg>
						</li>
					</ul>
					<p class="employee-reviews-fraction"><sup><strong>
						{{ e100Details['employee-rating'].toFixed(1) }}
					</strong></sup>/<sub>10</sub></p>
				</div>

				<div class="employee-review" v-if="e100Details['highlight-review']">
					<div class="employee-review-text-container">
						<p class="employee-review-text" v-html="toggleTruncateText ? doConvertWords(e100Details['highlight-review'], true) : doConvertWords(e100Details['highlight-review'])">
            </p>
					</div>
					<div class="employee-review__footer">
						<label class="employee-review-toggle-more" @click="toggleTruncateText = !toggleTruncateText">{{ toggleTruncateText ? 'More' : 'Less' }}</label>
						<a v-if="e100Details['slug']" class="employee-review-link" :href="`/organisation/${e100Details['slug']}#reviews`">View {{ e100Details['review-count'] }} reviews</a>
					</div>
				</div>
			</div>
		</div>

	</div>

</div>
</template>

<script>
export default {
	name: 'Escape100Card',

  props: {
    payload: {
      type: [Object],
      default: {}
    },
    year: {
    	type: [String,Number],
    },
    score: {
    	type: Number
    }
  },

  data() {
    return {
			moreInfo: true,
      toggleTruncateText: true,
      replaceWords: [
				{ from:'[b]',  to:'<b>' },
				{ from:'[/b]', to:'</b>' },
				{	from:'[u]',  to:'<u>' },
				{	from:'[/u]', to:'</u>' },
			],
    }
  },

	mounted() {
		//console.log("ESC100 Card:",this.payload)
	},

  methods: {
		doMoreInfo() {
			this.moreInfo = !this.moreInfo;
		},
    doCreateAlert() {

    },
    doConvertWords(str, truncate = false) {
      let text = truncate ? this.truncateText(str) : str;
      return this.$filters.convertWords(text, this.replaceWords)
    },
    truncateText(str, max = 25) {
      const arr = str.trim().split(' ');
      const ellipsis = arr.length > max ? '...' : '';
      return arr.slice(0, max).join(' ') + ellipsis;
    },
    getScoreDetail(cat) {
      let details = this.e100Details['score-detail'].filter(el => el.category.toLowerCase() == cat.toLowerCase());

      if(!details) {
        return false;
      }

      return details;
    },
    escapeScorePopup(cat, outcome) {
      this.emitter.emit("openModal", { name: 'EscapeScore', payload: {'category': cat, 'judged_outcome': outcome} });
    },
    jobListings(num) {
      let pluralJob = num > 1 ? 'Jobs' : 'Job'
      return `${num} ${pluralJob}`;
    }
  },

  computed: {
		moreInfoText() {
			return this.moreInfo ? 'More Info' : 'Close';
		},
    e100Details() {
      if(this.payload['e100-details'] && this.payload['e100-details'].length) {

        let result = this.payload['e100-details'].find(el => Number(el.year) === Number(this.year));

        return result;
      }
    }
  }
}
</script>
